export default function sortByCreatedDescending(a: any, b: any) {
  if (a._created > b._created) {
    return -1;
  }

  if (b._created > a._created) {
    return 1;
  }

  return 0;
}
